import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {CustomValidator} from '../../../services/custom-validator';
import {AuthenticationService} from '../../../services/authentication.service';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-change-temp-password',
  templateUrl: './change-temp-password.component.html',
  styleUrls: ['./change-temp-password.component.css']
})
export class ChangeTempPasswordComponent implements OnInit {

  changeTempPassForm: FormGroup;
  errorMessage = '';
  successMessage = false;
  redirectMessage = false;
  changeTempPassLogin = '';
  loginHandleAnswerQuiz = '';
  submit = false;

  get formData() {
    return this.changeTempPassForm.controls;
  }

  constructor(private formBuilder: FormBuilder, private router: Router, private authService: AuthenticationService) { }

  ngOnInit() {
    if (history.state.changeTempPassLogin == undefined) {
      this.onBack();
      return;
    } else {
      this.changeTempPassLogin = history.state.changeTempPassLogin;

      if (history.state.loginHandleAnswerQuiz !== undefined) {
        this.loginHandleAnswerQuiz = history.state.loginHandleAnswerQuiz;
      }
      this.createForm();
    }

  }

  createForm() {
    this.changeTempPassForm = this.formBuilder.group({
      currentPassword: '',
      newPassword: ['', [Validators.required, Validators.maxLength(100)]],
      confirmNewPassword: ['', [Validators.required, Validators.maxLength(100)]]
    }, { validators: [
      CustomValidator.validatePassword('newPassword', 'confirmNewPassword')
      ]});

    if (this.loginHandleAnswerQuiz == '') {
      this.changeTempPassForm.get('currentPassword').setValidators([Validators.required, Validators.maxLength(100)]);
    }
  }

  onSave() {
    this.submit = true;
    this.errorMessage = '';

    const filter = this.changeTempPassForm.getRawValue();
    this.authService.saveTempPassword(this.loginHandleAnswerQuiz, this.changeTempPassLogin,
      filter.currentPassword, filter.newPassword, filter.confirmNewPassword)
      .pipe(first())
      .subscribe(data => {
        this.successMessage = true;

        setTimeout(() => {
          this.successMessage = false;
          this.redirectMessage = true;
        }, 1500);

        setTimeout(() => {
          this.authService.logout()
            .subscribe(
              (data) => {
                this.onBack();
              },
              (err) => console.log(err)
            );

        }, 4000)
      }, error1 => {
        this.submit = false;
        this.errorMessage = error1;
      });
  }

  onBack() {
    this.router.navigate(['/login']);
  }
}
